import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

const Error404Svg = () => {
    return (
        <svg viewBox="0 0 600 200">
            <symbol id="s-text">
                <text textAnchor="middle" x="50%" y="50%" dy=".35em">
                    404!
                </text>
            </symbol>
            <use className="text" href="#s-text"></use>
            <use className="text" href="#s-text"></use>
            <use className="text" href="#s-text"></use>
            <use className="text" href="#s-text"></use>
            <use className="text" href="#s-text"></use>
        </svg>
    );
};

const Error404Alt = () => {
    return (
        <React.Fragment>
            <Row className="justify-content-center">
                <Col lg={6} xl={4} className="mb-4">
                    <div className="error-text-box">
                        <Error404Svg />
                    </div>

                    <div className="text-center">
                        <h3 className="mt-0 mb-2">Ops! Página não encontrada </h3>
                        <p className="text-muted mb-3">
                            Parece que você pode ter tomado um caminho errado. Não se preocupe... 
                            isso acontece com o melhor de nós. Você pode querer verificar sua conexão com a internet. 
                            Aqui está uma pequena dica que pode ajudar você a voltar ao caminho certo.
                        </p>
                        <Link to="/" className="btn btn-success waves-effect waves-light">
                            Voltar para o Dashboard
                        </Link>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Error404Alt;
